import { getRelatedProductsById } from "@/core/lib/api/main/main-shop-product";
import SwiperRelatedProducts from "./SwiperRelatedProducts";

type RelatedProductsProps = {
  productId: number;
};

export default async function RelatedProducts({
  productId,
}: RelatedProductsProps) {
  const relatedProduct = await getRelatedProductsById(productId)
  if (relatedProduct.related_products.length === 0) return null;


  return (
    <div className="w-full">
      <SwiperRelatedProducts items={relatedProduct.related_products} />
    </div>
  );
}
